import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetNewsCalendarEventsResponse,
  PostNewsCalendarEventsResponse,
  PutNewsCalendarEventsResponse,
  GetNewsCalendarEventByIdResponse,
} from '../response/calendar-events';

export class CalendarEventsService {
  static getCalendarEvents(params?: QueryParams) {
    return apiClient.get<GetNewsCalendarEventsResponse>(buildApiUrl('/api/v1/news-calendar/events'), params);
  }

  static postCalendarEvent(data: any) {
    return apiClient.createWithFile<PostNewsCalendarEventsResponse>(buildApiUrl('/api/v1/news-calendar/events'), data);
  }

  static putCalendarEvent(id: string, data: any) {
    const url = buildApiUrl('/api/v1/news-calendar/events/:id', { id });
    return apiClient.updateWithFile<PutNewsCalendarEventsResponse>(url, data);
  }

  static getCalendarEventById(id: string) {
    const url = buildApiUrl('/api/v1/news-calendar/events/:id', { id });
    return apiClient.get<GetNewsCalendarEventByIdResponse>(url, undefined);
  }

  static deleteCalendarEvent(id: string) {
    const url = buildApiUrl('/api/v1/news-calendar/events/:id', { id });
    return apiClient.delete<void>(url, undefined);
  }
}
